import { useWindowWidthAndHeight } from '../../../shared/hooks/customHooks';
import InseeExternalLink from '../component/inseeExternalLink';
import { useTranslation } from "react-i18next";
import './footerStyle.css'
import { NavLink } from 'react-router-dom';
const FooterWrapper = ()=>{
  const [width] = useWindowWidthAndHeight();
  const { t } = useTranslation();
  return(<>
    {
      width > 1150
      ? <footer className="footer" role="contentinfo">
          <hr></hr>
          <div className='footer-container'>
            <InseeExternalLink/>

            <div className='legal-container'>
              <NavLink to='static/legal-notice'><span >{t('footer_notice_credits')}</span></NavLink>
              <span className='separator'></span>
              <NavLink to='static/conditions'><span>{t('footer_conditions_of_redistribution')} </span></NavLink>
              <span className='separator'></span>
              <NavLink to='plan-site'><span>{t('footer_sitemap')}</span></NavLink>
              <span className='separator'></span>
              <NavLink to='static/accessibility'><span>{t('footer_accessibility')}</span></NavLink>
            </div>

            <div className='footer-copyright'>
              <span>©2026 - INSEE</span>
              <span> Tous droits réservés </span>
            </div>
          </div>
        </footer>
      : <footer className='small-footer' role="contentinfo">
          <hr></hr>
          <div className='small-footer-container'>
            <InseeExternalLink/> 
            <NavLink to='static/legal-notice'><span >{t('footer_notice_credits')}</span></NavLink>
            <NavLink to='static/conditions'><span>{t('footer_conditions_of_redistribution')} </span></NavLink>
            <NavLink to='plan-site'><span>{t('footer_sitemap')}</span></NavLink>
            <NavLink to='static/accessibility'><span>{t('footer_accessibility')}</span></NavLink>
          </div>
        </footer>
    }
  </>);
}

export default FooterWrapper;